/**
 * Initialize Leaflet map for shop CMS page.
 * Loads necessary CSS and JS dynamically.
 *
 * To ensure your map works, the CMS content must contain a container with a "map" identifier, including the following data attributes:
 * - data-marker-lat: Latitude of the marker
 * - data-marker-lng: Longitude of the marker
 *
 * You can also provide an optional data attribute:
 * - data-marker-text: Text for the marker popup. If no text is provided, no marker will be created.
 *
 * Here is an example of the map container in the CMS content:
 *
 * <div id="map" data-marker-lat="48.8079049" data-marker-lng="2.1237728" data-marker-text="<strong>Endurance-Store</strong>"></div>
 */
export async function initMap() {
	// Prevent re-initialization
	if (document.getElementById('map')?.classList.contains('leaflet-container')) return;

	// Fetch latitude and longitude from data attributes
	const mapData = document.getElementById('map');
	if (
		!mapData ||
		!mapData.getAttribute('data-marker-lat') ||
		!mapData.getAttribute('data-marker-lng')
	)
		return;

	const lat = parseFloat(mapData.getAttribute('data-marker-lat')!);
	const lng = parseFloat(mapData.getAttribute('data-marker-lng')!);

	await import('leaflet/dist/leaflet.css');
	const L = await import('leaflet');

	// Initialize map
	const map = new L.Map('map', { scrollWheelZoom: false });
	const osm = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		minZoom: 2,
		maxZoom: 20,
		attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
	});

	map.addLayer(osm);
	map.setView(new L.LatLng(lat, lng), 16);

	const marker = L.marker([lat, lng]).addTo(map);

	// Popup if text given
	if (mapData.getAttribute('data-marker-text')) {
		marker.bindPopup(mapData.getAttribute('data-marker-text')!);
	}
}
